import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
import "./assets/css/root.scss";


var firebaseConfig = {
  apiKey: "AIzaSyB_227lF77neB9vVtdIWZc6eCsZnASHBws",
  authDomain: "pixelswish-a92ef.firebaseapp.com",
  projectId: "pixelswish-a92ef",
  storageBucket: "pixelswish-a92ef.firebasestorage.app",
  messagingSenderId: "606278505689",
  appId: "1:606278505689:web:d2710fd3363628c6e05ac8"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
const projectAuth = firebase.auth();

export { projectAuth };
firebaseApp.analytics();

if(localStorage.getItem('access') == 'true') {
  store.state.userToken.signedin = true
} else {
  store.state.userToken.signedin = false
}

createApp(App).use(store).use(router).mount("#app");
 

